const Title = ["Hematocrit", "Hemoglobin", "Erythrocyte", "Leukocyte"];

export default Title;
